import React, { useEffect, useState } from 'react';

const StepTwo = ({ handleChange, contactInfosObject, isValid }) => {
    const [localInput, setLocalInput] = useState({
        phone_number: contactInfosObject.phone_number || '',
        website: contactInfosObject.website || '',
        address: contactInfosObject.address || '',
        city: contactInfosObject.city || '',
        postal_code: contactInfosObject.postal_code || ''
    });

    const optionalKeys = ['phone_number', 'website', 'address', 'city', 'postal_code'];

    useEffect(() => {
        validateInputs(localInput);
    }, [localInput]);

    const handleLocalChange = (key, value) => {
        setLocalInput(prev => ({ ...prev, [key]: value }));
    };

    const validatePhoneNumber = (number) => {
        // Basic phone validation
        const phoneRegex = /^\+?[0-9]{5,15}$/;
        return phoneRegex.test(number);
    };

    const validateWebsite = (url) => {
        const urlRegex = /^(https?:\/\/)?([\w\-]+(\.[\w\-]+)+)(\/[\w\-]*)*$/;
        return urlRegex.test(url);
    };

    const validateInputs = (inputs) => {
        const is_valid = Object.entries(inputs).every(([key, value]) => {
            if (optionalKeys.includes(key)) {
                // If optional field is filled, validate format if relevant
                if (key === 'phone_number' && value) return validatePhoneNumber(value);
                if (key === 'website' && value) return validateWebsite(value);
                if (value.length > 255) return false; // length check
                return true;
            }
            return value !== '';
        });

        handleChange(inputs);
        isValid(is_valid ? { step: '1' } : false);
    };

    return (
        <>
            <div className="columns">
                <div className="column">
                    <label className="label">Numéro de l'entreprise (Format International) (optionnel)</label>
                    <input
                        className="input"
                        type="text"
                        placeholder="+33412345678"
                        value={localInput.phone_number}
                        onChange={(e) => handleLocalChange('phone_number', e.target.value)}
                    />
                </div>
                <div className="column">
                    <label className="label">Site Web</label>
                    <input
                        className="input"
                        type="text"
                        placeholder="www.mon-entreprise.com"
                        value={localInput.website}
                        onChange={(e) => handleLocalChange('website', e.target.value)}
                    />
                </div>
            </div>

            <div className="columns">
                <div className="column">
                    <label className="label">Adresse complète</label>
                    <input
                        className="input"
                        type="text"
                        placeholder="55 Rue du Faubourg Saint-Honoré"
                        value={localInput.address}
                        onChange={(e) => handleLocalChange('address', e.target.value)}
                    />
                </div>
            </div>

            <div className="columns">
                <div className="column">
                    <label className="label">Ville</label>
                    <input
                        className="input"
                        type="text"
                        placeholder="Paris"
                        value={localInput.city}
                        onChange={(e) => handleLocalChange('city', e.target.value)}
                    />
                </div>

                <div className="column">
                    <label className="label">Code Postal</label>
                    <input
                        className="input"
                        type="text"
                        placeholder="75008"
                        value={localInput.postal_code}
                        onChange={(e) => handleLocalChange('postal_code', e.target.value)}
                    />
                </div>
            </div>
        </>
    );
};

export default StepTwo;